<template>
  <div>
    <div class="hiaTable truCodeEnabled VueTables VueTables--client table-responsive">
      <table class="VueTables__table table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th class="VueTables__sortable tenPercent">
              <span class="VueTables__heading">Orig. CPT</span>
            </th>
            <th v-if="worksheet.outpatientGrouperId === 1" class="VueTables__sortable">
              <span class="VueTables__heading">APC</span>
            </th>
            <th v-else class="VueTables__sortable">
              <span class="VueTables__heading">PI</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Weight</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Payment</span>
            </th>
            <th class="VueTables__sortable thirtyFivePercent">
              <span class="VueTables__heading">Desc</span>
            </th>
            <th class="VueTables__sortable tenPercent">
              <span class="VueTables__heading">Rec. CPT </span>
            </th>
            <th v-if="worksheet.outpatientGrouperId === 1" class="VueTables__sortable">
              <span class="VueTables__heading">APC</span>
            </th>
            <th v-else class="VueTables__sortable">
              <span class="VueTables__heading">PI</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Weight</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Payment</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading">Desc</span>
            </th>
            <th class="VueTables__sortable tenPercent">
              <span class="VueTables__heading">Reason For Change</span>
            </th>
            <th class="VueTables__sortable">
              <span class="VueTables__heading"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(value, key, index) in compGroupCPTs">
            <tr :id="index" class="codeTypeHeader" :key="key">
              <td colspan="12">
                {{ key }}
              </td>
            </tr>
            <tr v-for="value2 in value" :key="value2.cptID" :class="value2.recommendedCPT || value2.originalDeleted ? 'VueTables__row  highlight' : 'VueTables__row'">
              <td>
                <div v-if="value2.originalCPT">{{ value2.originalCPT }}</div>
                <div v-if="value2.originalModifierCalc" style="margin: 5px 0px 0px 0px;" :title="value2.originalModifierCalc" v-html="cptModifiers(value2.originalModifierCalc, value2.codeDesc)"></div>
              </td>
              <td style="white-space: nowrap;">
                <div v-if="worksheet.outpatientGrouperId === 1">{{ `${value2.originalAPC ? value2.originalAPC : ''}` }}</div>
                <div v-else>{{ `${value2.originalAscPI ? value2.originalAscPI : ''}` }}</div>
              </td>
              <td style="white-space: nowrap;">
                <div v-if="worksheet.outpatientGrouperId === 1">{{ `${value2.originalApcWtFormatted ? value2.originalApcWtFormatted : ''}` }}</div>
                <div v-else>{{ `${value2.originalAscWeight ? value2.originalAscWeight : ''}` }}</div>
              </td>
              <td style="white-space: nowrap;">
                <div v-if="worksheet.outpatientGrouperId === 1">{{ `${value2.originalApcFormatted ? value2.originalApcFormatted : ''}` }}</div>
                <div v-else>{{ `${value2.originalAscPaymentFormatted ? value2.originalAscPaymentFormatted : ''}` }}</div>
              </td>
              <td>
                <div style="text-transform: lowercase;" :title="value2.originalDescription">
                  {{ truncateDescription(value2.originalDescription) }}
                  <!-- <span v-if="value2.originalGrouperFlags" :title="getGrouperflagsTitle(value2.originalGrouperFlags)" class="grouperFlags">({{ value2.originalGrouperFlags }})</span> -->
                </div>
              </td>
              <td>
                <div v-if="value2.recommendedCPT">{{ value2.recommendedCPT }}</div>
                <div v-if="value2.recommendedModifierCalc" style="margin: 5px 0px 0px 0px;" :title="value2.recommendedModifierCalc" v-html="cptModifiers(value2.recommendedModifierCalc, value2.codeDesc)"></div>
              </td>
              <td style="white-space: nowrap;">
                <div v-if="worksheet.outpatientGrouperId === 1">{{ `${value2.recommendedAPC ? value2.recommendedAPC : ''} ` }}</div>
                <div v-else>{{ `${value2.recommendedAscPI ? value2.recommendedAscPI : ''}` }}</div>
              </td>
              <td style="white-space: nowrap;">
                <div v-if="worksheet.outpatientGrouperId === 1">{{ ` ${value2.recommendedApcWtFormatted ? value2.recommendedApcWtFormatted : ''}` }}</div>
                <div v-else>{{ ` ${value2.recommendedAscWeight ? value2.recommendedAscWeight : ''}` }}</div>
              </td>
              <td style="white-space: nowrap;">
                <div v-if="worksheet.outpatientGrouperId === 1">{{ `${value2.recommendedApcFormatted ? value2.recommendedApcFormatted : ''}` }}</div>
                <div v-else>{{ `${value2.recommendedAscPaymentFormatted ? value2.recommendedAscPaymentFormatted : ''}` }}</div>
              </td>
              <td>
                <div style="text-transform: lowercase;" :title="value2.recommendedDesc">
                  {{ truncateDescription(value2.recommendedDesc) }}

                  <!-- <span :title="getGrouperflagsTitle(value2.recommendedGrouperFlags)" v-if="(value2.recommendedDx && value2.recommendedGrouperFlags) || (value2.recommendedGrouperFlags && value2.recommendedGrouperFlags !== value2.originalGrouperFlags)" class="grouperFlags">({{ value2.recommendedGrouperFlags }})</span> -->
                </div>
              </td>
              <td>
                {{ value2.reasonForChange }}
              </td>
              <td>
                <el-button style="margin-right: 5px;" size="mini" v-if="(value2.recommendedCPT || value2.originalDeleted) && !(worksheet.hideExcludedCodesResponseFromNucleus && value2.codeType === 9)" type="text" @click="addResponse(value2)" :disabled="readOnly">Respond </el-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div style="color: #909399; margin: 0px 0px 0px 5px;" v-if="!compGroupCPTs.length">Not matching records</div>
    </div>
  </div>
</template>

<script>
import dateHelper from '@/mixins/date-helper'
import { format, parseISO } from 'date-fns'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'coderOutpatientCPTs',
  mixins: [dateHelper],
  props: ['worksheet', 'readOnly'],
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      loading: false,
      pxColumns: ['originalCpt', 'originalModifiers', 'origDesc', 'recommendedCPT', 'recommendedModifiers', 'recDesc', 'reasonForChangeDescription', 'response'],
      options: {
        filterable: false,
        filterByColumn: false,
        resizableColumns: false,
        queue: [],
        networkFunction: null,
        perPage: 100,
        rowClassCallback: row => {
          if (row.recommendedCPT || row.originalDeleted) {
            return 'highlight'
          }
          return ''
        },
        columnsClasses: {
          originalCpt: 'tenPercent',
          origDesc: 'thirtyFivePercent',
          recommendedCPT: 'tenPercent',
          recDescription: 'thirtyFivePercent',
          reasonForChange: 'tenPercent'
        },
        headings: {
          originalCpt: 'Original CPT',
          origDesc: 'Desc.',
          recommendedCPT: 'Recommended CPT',
          recDesc: 'Desc.',
          reasonForChange: 'Reason For Change',
          response: '',
          reasonForChangeDescription: 'Reason For Change'
        }
      }
    }
  },
  methods: {
    ...mapMutations('myProjects/', ['SET_RESPONSE_ROW']),
    truncateDescription(description) {
      const max = 100
      if (description && description.length > max) {
        return description.substring(0, max) + '...'
      }
      return description
    },
    getGrouperflagsTitle(flagList) {
      if (!flagList) {
        return
      }

      const flagMap = {
        AD: 'Affects DRG',
        CC: 'Complication/Comorbidity',
        HC: 'Hospital-Acquired Condition',
        MC: 'Complication/Comorbidity',
        R: 'Affects Risk of Mortality',
        S: 'Affects Severity of Illness',
        AP: 'Affects Patient Safety Indicators',
        EP: 'Excludes Patient Safety Indicators',
        AQ: 'Affects Quality Measures',
        EQ: 'Excludes Quality Measures',
        OR: 'Operative Procedure',
        NOR: 'Non-Operative Procedure'
      }

      const flags = flagList.split(',')
      const title = []
      flags.forEach(x => {
        title.push(`${x}: ${flagMap[x]}`)
      })

      return title.join('\n')
    },
    addResponse(row) {
      this.SET_RESPONSE_ROW(row)
    },
    getASCData(cpt, field, level) {
      const row = this.worksheet.cptsGrouping.find(x => x.cptID === cpt.cptID)

      const orGrouping = row.ascRecommendationsCptsAscGrouping.find(x => x.codeLevel === 0)
      const recGrouping = row.ascRecommendationsCptsAscGrouping.find(x => x.codeLevel === 1)

      if (level === 1 && orGrouping && recGrouping && orGrouping.payment_indicator === recGrouping.payment_indicator && orGrouping.payment === recGrouping.payment) {
        return '&nbsp;'
      }

      if (level === 0 && !orGrouping) {
        return '&nbsp;'
      }

      if (level === 0 && orGrouping && !orGrouping.payment_indicator) {
        return '&nbsp;'
      }

      if (level === 1 && !orGrouping && !recGrouping) {
        return '&nbsp;'
      }

      if (level === 1 && recGrouping && !recGrouping.payment_indicator) {
        return '&nbsp;'
      }

      switch (field) {
        case 'paymentIndicator':
          switch (level) {
            case 0:
              return orGrouping ? `<span title="${orGrouping.payment_indicator_description}">${orGrouping.payment_indicator}</span>` : '&nbsp;'
            case 1:
              if (orGrouping && !recGrouping) {
                return '<span title="ASC Deleted">DEL</span>'
              }
              if (orGrouping && recGrouping && recGrouping.payment_indicator === 'DEL') {
                return '<span title="ASC Deleted">DEL</span>'
              }
              return recGrouping ? `<span title="${recGrouping.payment_indicator_description}">${recGrouping.payment_indicator}</span>` : '&nbsp;'
          }
          break
        case 'ascWeight':
          switch (level) {
            case 0:
              return orGrouping ? orGrouping.weight : '&nbsp;'
            case 1:
              if (orGrouping && !recGrouping) {
                return '&nbsp;'
              }
              if (orGrouping && recGrouping && recGrouping.payment_indicator === 'DEL') {
                return '&nbsp;'
              }
              return recGrouping && recGrouping ? recGrouping.weight : '&nbsp;'
          }
          break
        case 'ascPaymentRate':
          switch (level) {
            case 0:
              return orGrouping ? orGrouping.percentage * 100 + '%' : '&nbsp;'
            case 1:
              if (orGrouping && !recGrouping) {
                return '&nbsp;'
              }
              if (orGrouping && recGrouping && recGrouping.payment_indicator === 'DEL') {
                return '&nbsp;'
              }
              return recGrouping && recGrouping ? recGrouping.percentage * 100 + '%' : '&nbsp;'
          }
          break
        case 'ascPayment':
          switch (level) {
            case 0:
              return orGrouping && orGrouping.payment !== null ? '$' + orGrouping.payment.toFixed(2) : '&nbsp;'
            case 1:
              return recGrouping && recGrouping.payment !== null ? '$' + recGrouping.payment.toFixed(2) : '&nbsp;'
          }
          break
      }
    },
    getAPCData(cpt, field, level) {
      const row = this.worksheet.cptsGrouping.find(x => x.cptID === cpt.cptID)

      const orGrouping = row.ascRecommendationsCptsGrouping.find(x => x.codeLevel === 0)
      const recGrouping = row.ascRecommendationsCptsGrouping.find(x => x.codeLevel === 1)

      if (level === 1 && orGrouping && recGrouping && orGrouping.apc === recGrouping.apc && orGrouping.payment === recGrouping.payment) {
        return '&nbsp;'
      }

      if (level === 0 && !orGrouping) {
        return '&nbsp;'
      }

      if (level === 1 && !orGrouping && !recGrouping) {
        return '&nbsp;'
      }

      switch (field) {
        case 'apc':
          switch (level) {
            case 0:
              return orGrouping ? `<span title="${orGrouping.apcDescription}">${orGrouping.apc}</span>` : '&nbsp;'
            case 1:
              if (recGrouping && recGrouping.apc === -1) {
                return '<span title="APC Deleted">DEL</span>'
              }
              return recGrouping ? `<span title="${recGrouping.apcDescription}">${recGrouping.apc}</span>` : '&nbsp;'
          }
          break
        case 'apcWeight':
          switch (level) {
            case 0:
              return orGrouping ? orGrouping.weight : '&nbsp;'
            case 1:
              if (recGrouping && recGrouping.apc === -1) {
                return '&nbsp;'
              }
              return recGrouping && recGrouping ? recGrouping.weight : '&nbsp;'
          }
          break
        case 'apcPaymentRate':
          switch (level) {
            case 0:
              return orGrouping ? orGrouping.percentage * 100 + '%' : '&nbsp;'
            case 1:
              if (recGrouping && recGrouping.apc === -1) {
                return '&nbsp;'
              }
              return recGrouping && recGrouping ? recGrouping.percentage * 100 + '%' : '&nbsp;'
          }
          break
        case 'statusIndicator':
          switch (level) {
            case 0:
              return orGrouping ? orGrouping.status_indicator : '&nbsp;'
            case 1:
              return recGrouping ? recGrouping.status_indicator : '&nbsp;'
          }
          break
        case 'apcPayment':
          switch (level) {
            case 0:
              return orGrouping && orGrouping.payment !== null ? '$' + orGrouping.payment.toFixed(2) : '&nbsp;'
            case 1:
              return recGrouping && recGrouping.payment !== null ? '$' + recGrouping.payment.toFixed(2) : '&nbsp;'
          }
          break
      }
    },
    cptModifiers(input, description) {
      // console.log(input)
      // console.log(description)
      if (!input) return '&nbsp;'

      const lines = input.split(/\r?\n/)
      const calDesc = description.split('-')[0].trim()
      const results = []

      for (const line of lines) {
        const trimmed = line.trim()

        // If the line starts with the description
        if (trimmed.startsWith(calDesc)) {
          // Remove the description
          const rest = trimmed.slice(calDesc.length).trim()

          // Remove leading '-' from each modifier but keep the value
          const cleaned = rest.replace(/-\s*/g, '').trim()

          results.push(cleaned)
        } else {
          // Leave the line fully intact
          results.push(trimmed)
        }
      }
      return results.join('<br>')
    }
  },
  computed: {
    ...mapGetters('dropdowns/', ['GET_VALUEFROMKEY']),
    compGroupCPTs() {
      return this.worksheet.cpts ? Object.groupBy(this.worksheet.cpts, ({ codeDesc }) => codeDesc) : []
    }
  }
}
</script>

<style scoped>
.grouperFlags {
  font-style: italic;
  text-transform: uppercase;
}

>>> .tenPercent {
  width: 10%;
}

>>> .twentyPercent {
  width: 20%;
}

>>> .thirtyFivePercent {
  width: 30%;
}

>>> .highlight {
  /* background-color: rgba(255, 196, 12, 0.1) !important; */
  font-weight: bold;
}

>>> .highlight {
  border-left: 3px solid #f56c6c;
}

/* >>>.highlight:hover {
    background-color: rgba(255, 196, 12, 0.2) !important;
  } */

>>> td {
  font-size: 13px !important;
}

>>> .feeScheduleHeader {
  color: #005695;
  border-top: 1px solid rgb(204, 204, 204);
  margin-top: 2px;
  padding-top: 2px;
  font-weight: normal;
  font-size: 11px;
}

>>> .feeScheduleData {
  border-top: 1px solid rgb(204, 204, 204);
  padding-top: 5px;
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: 10px 0px 10px 0px;
  width: 100%;
  color: #005695;
}

>>> #cptGrid.truCodeEnabled td {
  position: relative;
  padding-bottom: 32px;
}

>>> .codeTypeHeader {
  text-align: center;
  background: rgb(28, 60, 95) !important;
  color: #ffffff;
  font-weight: bold;
}
</style>
